/* Above ground winter covers hub and size pages: the finder bar, the size page's cover type chips (and the
   finder's ?type= arriving there), and the size rows' arrows. docs/decisions/2026-09-21-above-ground-winter-covers-page.md */
(function () {
  if (window.__apsAgwc) return;
  window.__apsAgwc = true;
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var data = null;
    var el = document.querySelector('[data-agwc-sizes]');
    if (el) { try { data = JSON.parse(el.textContent); } catch (e) { data = null; } }
    document.querySelectorAll('[data-agwc-finder]').forEach(function (f) {
      if (!data) return;
      var sh = f.querySelector('[data-f=shape]'), sz = f.querySelector('[data-f=size]'), ty = f.querySelector('[data-f=type]'), go = f.querySelector('[data-f=go]');
      sh.addEventListener('change', function () {
        var list = data[sh.value] || [];
        sz.innerHTML = '<option value="">Select a pool size</option>' + list.map(function (x) { return '<option value="' + x.url + '">' + x.label + '</option>'; }).join('');
        sz.disabled = !sh.value; ty.disabled = true; ty.value = ''; go.disabled = true;
      });
      sz.addEventListener('change', function () { ty.disabled = !sz.value; go.disabled = !sz.value; });
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!sz.value) return;
        window.location.href = sz.value + (ty.value ? '?type=' + encodeURIComponent(ty.value) : '');
      });
    });
    document.querySelectorAll('[data-agwc-fil]').forEach(function (fil) {
      var sec = fil.closest('section');
      function press(k) {
        fil.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.k === k)); });
        sec.querySelectorAll('.wc-gi').forEach(function (g) { g.hidden = !!k && g.dataset.k !== k; });
      }
      fil.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) press(b.dataset.k); });
      var want = new URLSearchParams(window.location.search).get('type');
      if (want && fil.querySelector('button[data-k="' + want + '"]')) press(want);
    });
    function over() {
      document.querySelectorAll('[data-agwc-rail]').forEach(function (r) {
        var t = r.querySelector('.wc-track');
        r.classList.toggle('over', t.scrollWidth > t.clientWidth + 2);
      });
    }
    document.querySelectorAll('[data-agwc-rail]').forEach(function (r) {
      var t = r.querySelector('.wc-track');
      r.querySelector('.wc-arr.l').addEventListener('click', function () { t.scrollBy({ left: -t.clientWidth * 0.8, behavior: 'smooth' }); });
      r.querySelector('.wc-arr.r').addEventListener('click', function () { t.scrollBy({ left: t.clientWidth * 0.8, behavior: 'smooth' }); });
      var on = t.querySelector('.on');
      if (on) t.scrollLeft = Math.max(0, on.offsetLeft - t.clientWidth / 2 + on.clientWidth / 2);
    });
    over();
    window.addEventListener('resize', over);
  });
})();
